export const getCopy = () => ({
  tooltip:
    'This resource comes from an external source and therefore any changes made will be overwritten',
  lastUpdated: 'Last synced on',
  failed: 'Failed to load last updated date',
});
